import React, { useState } from "react";
import authentication from "../../images/authenticaion1.png";
import { ImArrowRight2 } from "react-icons/im";
import ScanCode from "./ScanCode";
import { FiMail } from "react-icons/fi";
import { Link } from "react-router-dom";
const CreateAccount = () => {
  return (
    <div>
      <div className="grid lg:grid-cols-5  grid-cols-1 h-[calc(100vh-80px)]  ">
        <div className="  flex flex-col col-span-2  justify-center items-center p-5 gap-8">
          <h2 className="text-black text-3xl font-bold ">
            Create your Knoct account{" "}
          </h2>
          <ScanCode font={"text-gray-500 font-semibold"} />
          <div className="w-full  px-5 space-y-8 py-7">
            <div className="flex justify-center flex-col items-center gap-5">
              <button className="  w-full h-[76px] bg-primary text-[22px] font-bold rounded text-white">
                Submit
              </button>
              <div className="divider font-bold">OR</div>{" "}
              <div className="w-full">
                <Link to={"/signupemail"}>
                  <button className="  w-full h-[76px] bg-accent   text-[22px] font-bold rounded text-white flex justify-center items-center gap-2">
                    {" "}
                    <FiMail className="4xl" /> Signup with email
                  </button>
                </Link>
              </div>
              <p className="font-semibold text-xl">
                Already have an account?
                <span className="text-primary font-bold cursor-pointer">
                  {" "}
                  <Link to={"/login"}>Login</Link>
                </span>{" "}
              </p>
            </div>
          </div>
        </div>
        <div className="bg-primary  flex flex-col  justify-center items-center text-white lg:px-10 col-span-3  gap-6 lg:p-10 p-3 text-center">
          <div>
            <h3 className="font-bold lg:text-[34px] text-xl mb-2">
              Tip of the day :
            </h3>
            <p className="lg:text-[30px] text-xl">
              Never share your wallet password with anyoune
            </p>
          </div>
          <img src={authentication} alt="" className="w-2/3" />
          <p className="lg:text-[24px] text-xl text-center">
            The weakeset link in security is the human factor. Never share your
            wallet passsword. Also, never login untrusted devices as the
            password might be save in keychain.
          </p>
          <p className="lg:text-[26px] text-xl font-bold flex justify-center items-center gap-2 cursor-pointer">
            <span> More on blog</span> <ImArrowRight2 />
          </p>
        </div>
      </div>
    </div>
  );
};

export default CreateAccount;
